import Util from "/js/components/Util.js";
import ItemManager from "./ItemManager.js";

export default {
  ACTION_AUTO: 'auto',
  ACTION_CLICK: 'click',
  ACTION_DRAG: 'drag',
  ACTION_DROP: 'drop',
  ACTION_ADD: 'add',
  ACTION_REMOVE: 'remove',
  ACTION_HOVER: 'hover',
  ACTION_SELECT: 'select',
  ACTION_DESELECT: 'deselect',
  ACTION_HIDE: 'hide',
  ACTION_SHOW: 'show',
  ACTION_CHANGE: 'change',
  ACTION_INPUT: 'input',
  ACTION_START: 'start',
  ACTION_END: 'end',
  ACTION_CONNECT: 'connect',
  SYSTEM: {auto:true},
  
  MAX_SIZE: 100000, //approx bytes
  sizeLength: 0,
  counter: 0,
  overLimit: false,

  init() {
    let me = this;

    me.counter = 0;
    me.overLimit = false;
    me. sizeLength = 0;

    $('#g-item-manager').on('click', ".e-event-click", function(e) {
      me.saveData(undefined, me.ACTION_CLICK, $(this).attr('data-event-id'));
    });

    $('#g-item-manager').on('change', ".e-event-change", function(e) {
      me.saveData($(this).val(), me.ACTION_CHANGE, $(this).attr('data-event-id'));
    });   

  },

  saveData(d, action, id) {
    
    let data = {
      'c': this.counter++,
      "ts": Util.getTimeStamp(),
      'a': action,
      'id': id,
      'd': d
    }

    $('#g-item-manager').trigger({
      type:'event-stream',
      detail: data
    });
    //console.log(data);
      
    
    if (!this.overLimit) {
      this.sizeLength += JSON.stringify(data).length;

      if (this.sizeLength <= this.MAX_SIZE) {
        ItemManager.setEventData(data);
      } else {
        this.overLimit = true;
        ItemManager.setEventData({
          "ts": Util.getTimeStamp(),
          'a': 'max-event-size-reached',
        });
      }
    }
  },
};
